module.exports = __webpack_public_path__ + "img/bo.29001c92.svg";